/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Icons } from '@sede-enterprise/shell-ds-react-framework';
import { ColumnTitleContainer } from '../style';
import FilterOptions from './Filter';
import { IFullState } from '../../../types/All.type';
import Button from '../../Button';

const { ChevronUpDown, ArrowDownSquare, ArrowUpSquare } = Icons;

const ColumnTitle = (props: any) => {
  const { column, sortedColumn, handleSort = () => {}, handleFilter = () => {}, filter } = props;

  const [sort, setSort] = useState<string | null>(null);
  const { isDark } = useSelector((state: IFullState) => state.Theme);

  const getOrder = (currentOrder) => {
    switch (currentOrder) {
      case 'Asc':
        return 'Desc';
      case 'Desc':
        return 'Asc';
      default:
        return 'Asc';
    }
  };

  const handleSortOnClick = () => {
    const order = getOrder(sort);
    setSort(order);
    handleSort(column.fieldName, column.accessKey, order, column?.nestedObject, column?.type);
  };

  useEffect(() => {
    const order = column.accessKey === sortedColumn?.accessKey ? sortedColumn?.order : null;
    setSort(order);
  }, [sortedColumn]);

  const getIcon = () => {
    switch (sort) {
      case 'Asc':
        return <ArrowUpSquare width={15} height={15} />;
      case 'Desc':
        return <ArrowDownSquare width={15} height={15} />;
      default:
        return <ChevronUpDown width={15} height={15} />;
    }
  };

  return (
    <ColumnTitleContainer color={isDark ? '#fff' : 'rgb(41, 41, 41)'}>
      <div className='sorting-wrapper'>
        <div className='shell-table-column-title'>{column?.title}</div>
        {column?.filter && (
          <FilterOptions column={column} handleFilter={handleFilter} filter={filter} />
        )}
        {column?.sorting && (
          <Button
            size='small'
            iconOnly
            variant='transparent'
            data-testid='sorting'
            onClick={column?.sorting ? handleSortOnClick : () => {}}
            icon={getIcon()}
          />
        )}
      </div>
    </ColumnTitleContainer>
  );
};

export default ColumnTitle;
